






























































import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import {
  defineComponent,
  computed,
  toRefs,
  useRouter
} from '@nuxtjs/composition-api'
import { APP_NS, AppState } from '~/store/modules/shared/app/state'
import { useNamespacedStore } from '~/compositions/store'
import { defineComponentTranslations } from '~/utils/i18n'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useDeps } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  i18n: defineComponentTranslations({
    trade_your_classifieds: {
      en:
        'Now you can trade your classifieds with the classifieds of other {site} users, with just one swipe.',
      el:
        'Τώρα μπορείς να ανταλλάξεις τις αγγελίες σου με αγγελίες άλλων χρηστών του {site}, μόνο με ένα swipe.'
    },
    trade_your_classifieds_anon: {
      en:
        'In order to enable trades you need to be enrolled as a {user} and be logged in to your account.',
      el:
        'Για τη λειτουργία των ανταλλαγών θα πρέπει να είσαι {user} και να έχεις συνδεθεί στο λογαριασμό σου.'
    }
  }),
  setup(props) {
    const { fields } = toRefs(props)
    const { getters } = useNamespacedStore<AppState>(APP_NS)
    const isPlot = computed(() => getters('isPlot'))
    const { state: formState } = useNamespacedStore<FormState>(
      CLASSIFIED_FORM_NS
    )
    const router = useRouter()

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const isAnon = computed(() => userGetters('isSingleOrAnon'))

    const classifiedId = computed(() => formState.classifiedId)

    const tradesPageUrl = computed(() => {
      const tradesSettingsFields = fields.value.find(
        f => f.name === 'trades_settings'
      )
      if (tradesSettingsFields?.specs.show_trades_link && classifiedId.value) {
        return router.resolve({
          name: '__trades_swipe',
          params: { cid: classifiedId.value.toString() }
        }).href
      }
      return null
    })

    const [legacyUrlService] = useDeps(LegacyUrlService)

    const loginUrl = computed(() => {
      if (process.client) {
        return `${legacyUrlService.getUserLoginUrl()}?gotonext=${
          window.location.href
        }`
      }
      return legacyUrlService.getUserLoginUrl()
    })

    const formIsDispatched = computed(() => formState.isDispatched)

    const showAnonTexts = computed(() => {
      return (
        isAnon.value && !formIsDispatched.value && fields.value.length === 0
      )
    })

    return {
      isPlot,
      tradesPageUrl,
      ciExternalLink,
      isAnon,
      loginUrl,
      showAnonTexts
    }
  }
})
